import type { DsConfigurationModel } from "@3volutionsag/ngx-rooms-lib";
import type { RootConfigurationModel } from "../root-config.model";

export class FetchDsConfiguration {
	static readonly type = "[Configuration] Load DsConfiguration";
	constructor(
		public resourceId?: number,
		public asServiceUser = false,
	) {}
}

export class SetDsConfiguration {
	static readonly type = "[Configuration] Set DsConfiguration";
	constructor(public dsConfiguration: DsConfigurationModel) {}
}

export class SetRootConfiguration {
	static readonly type = "[Configuration] Set RootConfiguration";
	constructor(public rootConfig: RootConfigurationModel) {}
}

export class ResetDsConfiguration {
	static readonly type = "[Configuration] Reset DsConfiguration";
}
